document.querySelectorAll('.bs-carousel').forEach(carousel => {
    let anim, item, items, swipe,
        swipeMin = 25,
        swipeStart,
        t = 500,
        wrapper = carousel.querySelector('.row');

    wrapper.addEventListener('touchstart', (e) => {
        swipeStart = e.changedTouches[0].screenX;
        wrapper.prepend(wrapper.lastElementChild);
        item = wrapper.firstElementChild;

        let width = item.offsetWidth;
        item.style.marginLeft = -width + "px";

        wrapper.addEventListener('touchmove', (e) => {
            swipe = e.changedTouches[0].screenX - swipeStart;
            // console.log(window.getComputedStyle(item).getPropertyValue("margin-left"));
            item.style.marginLeft = -width + swipe + "px";
        })
    })

    wrapper.addEventListener('touchend', (e) => {
        wrapper.removeEventListener('touchmove', (e));
        if (Math.abs(swipe) >= swipeMin) {
            e.preventDefault();
            move(-swipe);
        }
    })

    carousel.querySelectorAll('[data-dir]').forEach((e) => {
        e.addEventListener('click', (e) => {
            let swipe = e.currentTarget.dataset.dir === 'right' ? swipeMin : -swipeMin;
            wrapper.prepend(wrapper.lastElementChild);
            item = wrapper.firstElementChild;
            item.style.marginLeft = -item.offsetWidth + 'px';
            move(swipe);
        });
    });

    function move(swipe) {
        if(anim) {
            anim.finish();
        }
        if (swipe > 0) {
            anim = item.animate({marginLeft: -(item.offsetWidth * 2) + "px"}, t);
            anim.addEventListener('finish', (e) => {
                wrapper.append(item);
                item.removeAttribute('style');
                wrapper.append(wrapper.firstElementChild);
            });
        } else {
            anim = item.animate({marginLeft: 0 + 'px'}, t);
            anim.addEventListener('finish', (e) => {
                item.removeAttribute('style');
            });
        }
    }
})

